import { CoachStatus, CoachSubStatus, StudentGroupReassignmentReason } from '@airreading/common/data';

export const pauseReassignmentTriggerSubStatuses: CoachSubStatus[] = [
  CoachSubStatus.non_renewal_of_contract,
  CoachSubStatus.offboard_requested,
  CoachSubStatus.zoom_unresponsive,
];

export function hasPauseReassignmentTrigger(status: CoachStatus | undefined, subStatuses: CoachSubStatus[]): boolean {
  return (
    status === CoachStatus.pause &&
    subStatuses.some((subStatus) => pauseReassignmentTriggerSubStatuses.includes(subStatus))
  );
}

/**
 * Non-renewal keeps its own default even when Zoom Unresponsive is also selected.
 * Zoom Unresponsive otherwise wins over Offboard Requested.
 */
export function defaultReasonForPauseSubStatuses(subStatuses: CoachSubStatus[]): StudentGroupReassignmentReason {
  if (subStatuses.includes(CoachSubStatus.non_renewal_of_contract)) {
    return StudentGroupReassignmentReason.contract_termination_or_non_renewal;
  }
  if (subStatuses.includes(CoachSubStatus.zoom_unresponsive)) {
    return StudentGroupReassignmentReason.unresponsive_to_zoom_link;
  }
  return StudentGroupReassignmentReason.teacher_request;
}
